import type { AxiosRequestConfig } from 'axios';
import { assertRecordWritable } from '@/utils/recordReview';
import { post } from '@/utils/network/axios-helper';
import type { IPageDataBoxType, IGetAnswerList, ISaveAnswerList, IParamsType, IResult } from '@/utils/ctype';
import { EXAM_REQUEST_TIMEOUT_MS } from './start';

export const getListeningContent = (params: IParamsType, config?: AxiosRequestConfig) => {
  return post<{list: IPageDataBoxType[];}>('/api/simulate/get-listening-info', params, {
    timeout: EXAM_REQUEST_TIMEOUT_MS,
    ...config,
  });
};

export const getAnswerList = (params: IParamsType, config?: AxiosRequestConfig) => {
  return post<IGetAnswerList>('/api/simulate/get-listening-draft-info', params, {
    timeout: EXAM_REQUEST_TIMEOUT_MS,
    ...config,
  });
};

export const saveAnswerList = (params: ISaveAnswerList, config?: AxiosRequestConfig) => {
  assertRecordWritable();
  return post<{id:number;}>('/api/simulate/save-listening-info', params, {
    timeout: EXAM_REQUEST_TIMEOUT_MS,
    ...config,
  });
};

export const submitAnswer = (params: IParamsType, config?: AxiosRequestConfig) => {
  assertRecordWritable();
  return post<{id:number;}>('/api/simulate/finished-listening', params, {
    timeout: EXAM_REQUEST_TIMEOUT_MS,
    ...config,
  });
};

export const getResult = (params: IParamsType) => {
  return post<IResult>('/api/simulate/get-listening-record-answer-info', params);
};
